import React, { useState, useEffect, useCallback } from "react";
import { Input } from "@nextui-org/input";
import { onChangeInput } from "../../utils/onChangeInput.ts";
import { onKeyDown } from "../../utils/onKeyDownFunction";
import messages from "../../errorTypes/Types.ts";
import {
  validateSquareProfileLength,
  validateSquareProfileQuantity,
  validateSquareProfileThickness,
  validateSquareProfileWidth,
} from "../../utils/validateEachType";

const ProfilZamknietyKwadratowy = ({ density, onWeightChange }) => {
  const [width, setWidth] = useState("");
  const [thickness, setThickness] = useState("");
  const [length, setLength] = useState("");
  const [count, setCount] = useState(1);

  const [errorWidth, setErrorWidth] = useState(null);
  const [errorThickness, setErrorThickness] = useState(null);
  const [errorLength, setErrorLength] = useState(null);
  const [errorCount, setErrorCount] = useState(null);

  const calculateWeight = useCallback(() => {
    const width_m = Number(width) / 1000; // mm to m
    const thickness_m = Number(thickness) / 1000; // mm to m
    const outerVolume = Number(width_m) ** 2; //
    const innerVolume = Number(width_m - 2 * thickness_m) ** 2; //
    const volume = Number(outerVolume) - Number(innerVolume); //
    const density_kg_m3 = density * 1000; // kg/m^3

    const weightPerMeter = Number(volume) * Number(density_kg_m3) * count; //
    const totalWeight = weightPerMeter * Number(length) * count; //
    onWeightChange({
      totalWeight: totalWeight.toFixed(3),
      totalWeightPerKg: weightPerMeter.toFixed(3),
    });
  }, [width, thickness, length, count, density]);

  useEffect(() => {
    const handler = setTimeout(() => {
      calculateWeight();
    }, 100); // Opóźnienie 100ms

    return () => {
      clearTimeout(handler);
    };
  }, [calculateWeight]);

  return (
    <div className="obliczenia">
      <div className="obliczenia-inputs">
        <label htmlFor="width-input">[A] Wpisz szerokość profilu(mm)</label>
        <Input
          id="width-input"
          type="text"
          autoComplete="off"
          value={width}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setWidth,
              validateSquareProfileWidth,
              4,
              2,
              setErrorWidth,
              messages.profilZamKw.width
            );
          }}
          onBlur={() => {
            if (!validateSquareProfileWidth(width)) {
              setErrorWidth("Niepoprawny format szerokości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setWidth)}
        />
        {errorWidth && <p className="text-error-text">{errorWidth}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="thickness-input">[B] Wpisz grubość ścianki (mm)</label>
        <Input
          id="thickness-input"
          type="text"
          autoComplete="off"
          value={thickness}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setThickness,
              validateSquareProfileThickness,
              2,
              2,
              setErrorThickness,
              messages.profilZamKw.thickness
            );
          }}
          onBlur={() => {
            if (!validateSquareProfileThickness(thickness)) {
              setErrorThickness("Niepoprawny format grubości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setThickness)}
        />
        {errorThickness && <p className="text-error-text">{errorThickness}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="length-input">[C] Wpisz długość profilu (m)</label>
        <Input
          id="length-input"
          type="text"
          autoComplete="off"
          value={length}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setLength,
              validateSquareProfileLength,
              2,
              2,
              setErrorLength,
              messages.profilZamKw.length
            );
          }}
          onBlur={() => {
            if (!validateSquareProfileLength(length)) {
              setErrorLength("Niepoprawny format długości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setLength)}
        />
        {errorLength && <p className="text-error-text">{errorLength}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="count-input">Wpisz ilość (szt.)</label>
        <Input
          id="count-input"
          type="text"
          autoComplete="off"
          value={count}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setCount,
              validateSquareProfileQuantity,
              5,
              0,
              setErrorCount,
              messages.profilZamKw.quantity
            );
          }}
          onBlur={() => {
            if (!validateSquareProfileQuantity(count)) {
              setErrorCount("Niepoprawny format ilości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setCount)}
        />
        {errorCount && <p className="text-error-text">{errorCount}</p>}
      </div>
    </div>
  );
};

export default ProfilZamknietyKwadratowy;
